/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveySeasonStepKey {
    OVERVIEW = 'overview',
    CREATE_DRAFT_PLAN = 'createDraftPlan',
    SELECT_SURVEYS_FOR_PLAN = 'selectSurveysForPlan',
    REVIEW_SURVEY_STATUS = 'reviewSurveyStatus',
    ACTIVATE_PLAN = 'activatePlan',
    REVIEW_PLAN_CONFIGURATION = 'reviewPlanConfiguration',
    REPLACE_SURVEYS = 'replaceSurveys',
    REVIEW_AND_CONFIRM = 'reviewAndConfirm',
}
